import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const base = createSelector(
    (state: RootState) => state,
    (state) => state.userDeleteRestore
)

export const selectIsUserDeleteRestoreModalOpen = createSelector(base, (s) => s.isModalOpen)
export const selectUserDeleteRestoreMode = createSelector(base, (s) => s.mode)
export const selectUserDeleteRestoreOnSuccess = createSelector(base, (s) => s.onSuccess)
export const selectUserDeleteRestoreUserId = createSelector(base, (s) => s.currentUserId)
